import React from 'react';
import {Button} from 'antd';
import "./ButtonComponent.scss"

interface ButtonProps {
    className?: string;
    loadingText?: string;
    loading?: boolean;
    gradient?: boolean;// Optional loading text when button is in loading state
    type?: "submit" | "button" | "reset";
    variant?: "outlined" | "dashed" | "solid" | "filled" | "text" | "link";
    color?: "default" | "primary" | "danger";
    disabled?: boolean;
    onClick?:any;
    size?: 'small' | 'middle' | 'large';
    shape?: 'default' | 'circle' | 'round';
    block?: boolean;
    icon?: React.ReactNode;
}

const ButtonComponent = (props: React.PropsWithChildren<ButtonProps>) => {
    const {
        loading,
        className,
        gradient,
        loadingText,
        children,
        icon,
        type,
        variant,
        color = 'default' as ButtonProps["color"],
        disabled,
        onClick = undefined,
        size,
        shape,
        block
    } = props;

    return (
        <Button
            loading={loading}
            disabled={disabled}
            // icon={loading ? <LoadingOutlined/> : icon}
            onClick={onClick}
            icon={icon}
            htmlType={type}
            className={`${gradient ? "gradient-button" : ''} ${className}`}
            variant={variant}
            color={color}
            size={size}
            shape={shape}
            block={block}
        >
            {loading && loadingText ? loadingText : children}
        </Button>
    );
};

export default ButtonComponent;
